import React from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface Props {
  label: string
  onClick: () => void
  isSelected?: boolean
}

const MeetingFormatButton: React.FC<Props> = ({
  label,
  onClick,
  isSelected = false,
}) => {
  return (
    <Button
      variant="outline"
      aria-pressed={isSelected}
      className={cn(
        `h-auto rounded-lg border-[1.5px] bg-white px-4 py-2 font-normal
        shadow-none`,
        isSelected
          ? `border-primary font-semibold text-primary hover:bg-white
            hover:text-primary`
          : 'border-gray-300 text-foreground-dark',
      )}
      onClick={onClick}
    >
      {label}
    </Button>
  )
}

export default MeetingFormatButton
